module.exports = __webpack_public_path__ + "static/media/f67588b8490ca28797f20af94930ddda.e691516a.JPEG";